<template>
  <tr>
    <td>{{ props.piddata.uid }}</td>
    <td>{{ formattedDate }}</td>
    <td>{{ props.piddata.count }}</td>
    <td>{{ props.piddata.journeyCount }}</td>
    <td>{{ formattedLines }}</td>
    <td>{{ formattedVehicles }}</td>
  </tr>
</template>

<script setup>
import { defineProps, computed, inject } from 'vue';

const dataStore = inject('datastore');

const props = defineProps({
  piddata: {
    type: Object,
    required: true
  }
});

const formattedDate = computed(() => {
  if (!props.piddata || !props.piddata.date) {
    return;
  }
  const date = new Date(props.piddata.date);
  return date.toLocaleDateString(undefined, { weekday: 'long', year: 'numeric', month: 'short', day: 'numeric' });
});

const formattedLines = computed(() => {
  if (!props.piddata.lineNames || !props.piddata.lineNames.length) return '';
  // Sort and join
  return props.piddata.lineNames.sort().join(', ');
});

const formattedVehicles = computed(() => {
  if (!props.piddata.vehicleRefs || !props.piddata.vehicleRefs.length) return '';
  // Sort and join
  return props.piddata.vehicleRefs.sort().join(', ');
});

function getDayBounds(date) {
  const start = new Date(date);
  start.setHours(0, 0, 0, 0); // Beginning of the day

  const end = new Date(date);
  end.setHours(23, 59, 59, 999); // End of the day

  return { start: Math.floor(start.getTime() / 1000), end: Math.floor(end.getTime() / 1000) };
}



function addJourney() {
  console.log(`Addjourney ${props.journey}`)
}

</script>

<style scoped>
/* Add row-specific styles here if needed */
</style>